// NEW EVAL EXCLUSION REASONS
export const EVAL_EXCLUSION_REASONS = {
  DESIRED_TIMESLOTS_NOT_AVAILABLE: 'Desired Timeslots not available for Client',
  ELIGIBILITY_INACTIVE_CLIENT: 'Client is Inactive when running the eligibility check',
  ELIGIBILITY_ERROR: 'Error from Stedy when running the eligibility check',
  NO_PCP_INFO: `Client does not have their physician's information`,
  HAS_QUESTION: 'Bailout to Jotform due to question',
};

export const DIRECT_SIGNUP_MIXPANEL_EVENTS = {
  ADD_SECONDARY_INSURANCE: 'Direct Signup v1 - Asked to add secondary insurance',
  CHANGE_APPOINTMENT: 'Direct Signup v1 - Asked to change appointment time',
  CHANGE_PAYMENT_METHOD: {
    FROM_PRIVATE_PAY: 'Direct Signup v1 - Asked to change payment method (was private pay)',
    FROM_INSURANCE: 'Direct Signup v1 - Asked to change payment method (was insurance)',
  },

  PORTAL_NAVBAR: {
    SIGN_UP_NEW_CLIENT: 'Direct Signup v1 - Portal Navbar - Clicked to sign up new client',
  },

  CONTACT_CHECKER: {
    LOGGED_IN: 'Direct Signup v1 - Contact Checker - User arrived Logged In',
    LOGGED_OUT: 'Direct Signup v1 - Contact Checker - User arrived Logged Out',
    TRIGGERED_LOGIN: {
      TRIGGERED_MODAL: 'Direct Signup v1 - Contact Checker - Triggered Login modal',
      SUCCESS: 'Direct Signup v1 - Contact Checker - Logged in successfully',
      FAILURE: 'Direct Signup v1 - Contact Checker - Login failed',
    },
    TRIGGERED_LOGOUT: 'Direct Signup v1 - Contact Checker - Triggered Logout',

    PICKED_EXISTING_CONTACT: 'Direct Signup v1 - Contact Checker - Picked existing contact',
    PICKED_NEW_CONTACT: 'Direct Signup v1 - Contact Checker - Picked new contact',
  },

  STEPS: {
    FILTERS: 'Direct Signup v1 - Starting flow - Enter filters',
    URL_FILTERS: 'Direct Signup v1 - Starting flow - Filters via URL params',
    URL_FILTERS_DETAILS: {
      HAS_INSURANCE: 'Direct Signup v1 - Starting flow - URL params with insurance name',
      HAS_NON_LISTED_INSURANCE: 'Direct Signup v1 - Starting flow - URL params with insurance not listed',
      HAS_NO_INSURANCE: 'Direct Signup v1 - Starting flow - URL params with no insurance (private pay)',
    },
    LANDING_PAGE: {
      BASE: 'Direct Signup v1 - Landing Page',
      CHOSEN_SINGLE: 'Direct Signup v1 - Landing Page - Chosen Single Evaluation',
      CHOSEN_SPLIT: 'Direct Signup v1 - Landing Page - Chosen Split Evaluation',
      EXPERIMENT: {
        NO_LANDING_SPLITS: 'Direct Signup v1 - Experiment - No Landing Page - Split Eval',
        NO_LANDING_SINGLES: 'Direct Signup v1 - Experiment - No Landing Page - 60 Minute Eval',
        LANDING_PAGE_SPLITS: 'Direct Signup v1 - Experiment - Landing Page - Split Eval',
        LANDING_PAGE_SINGLES: 'Direct Signup v1 - Experiment - Landing Page - 60 Minute Eval',
      },
    },
    REDIRECT_TO_JOTFORM: {
      FULL_FORM: 'Direct Signup v1 - Redirect to JotForm - Full form',
      INSURANCE_CARD: 'Direct Signup v1 - Redirect to JotForm - Insurance card',
    },
    REDIRECTED_TO_SELF_PAY: {
      LANDING_PAGE_VIEWED: 'Direct Signup v1 - Self Pay - Landing Page for Self Pay Viewed',
      PAYMENT_COMPLETED: 'Direct Signup v1 - Self Pay - Payment Completed After Landing Page Viewed',
    },
    EVAL: {
      TIMESLOTS: 'Direct Signup v1 - Evaluation - Pick Time',
      SCHEDULE: {
        SINGLE: 'Direct Signup v1 - Evaluation - Schedule',
        SPLIT_FIRST: 'Direct Signup v1 - Evaluation - Schedule Split Evaluation - First split',
        SPLIT_SECOND: 'Direct Signup v1 - Evaluation - Schedule Split Evaluation - Second split',
        SPLIT_PICK_THERAPIST: 'Direct Signup v1 - Evaluation - Schedule Split Evaluation - Pick therapist',
        SKIP_SECOND_SPLIT: 'Direct Signup v1 - Evaluation - Schedule Split Evaluation - Skipping Second split',
        BAILOUT_TO_SINGLE:
          'Direct Signup v1 - Evaluation - Schedule Split Evaluation - Bailing out to single evaluation',
        BAILOUT_TO_SPLITS:
          'Direct Signup v1 - Evaluation - Schedule Split Evaluation - Bailing out to split evaluations',
        FORCED_REDIRECTS: {
          SPLITS_NOT_ALLOWED: 'Direct Signup v1 - Evaluation - Schedule - Forcing single evaluation, user not allowed',

          SPLITS_UNAVAILABLE:
            'Direct Signup v1 - Evaluation - Schedule - Low availability for split evaluations - Redirecting to Jotform',

          SINGLES_UNAVAILABLE:
            'Direct Signup v1 - Evaluation - Schedule - Low availability for single evaluations - Redirecting to Jotform',

          PREFILLED_APPOINTMENT:
            'Direct Signup v1 - Evaluation - Schedule - Skipping schedule step due to prefilled appointment',
        },
      },
      FORM: {
        NO_PCP: 'Direct Signup v1 - No PCP',
        NO_PCP_BAILOUT: 'Direct Signup v1 - No PCP but REQUIRED - Bailout to jotform',
      },
      PCP: {
        PCP_REQUIRED: 'Direct Signup v1 - PCP Information Is REQUIRED',
        PCP_PREFILLED: 'Direct Signup v1 - PCP Information Prefilled from Eligibility',
        PCP_FOUND: 'Direct Signup v1 - PCP Information Found by user on NPI database',
        PCP_MANUAL: 'Direct Signup v1 - PCP Information Manually entered by user',
      },
      FORM_INSURANCE: {
        MEDICAID: 'Direct Signup v1 - Evaluation - Form - Insurance (medicaid)',
        MEDICARE: 'Direct Signup v1 - Evaluation - Form - Insurance (medicare)',
        COMMERCIAL: 'Direct Signup v1 - Evaluation - Form - Insurance (commercial)',
        OUT_OF_NETWORK: 'Direct Signup v1 - Evaluation - Form - Insurance (commercial - out of network)',
      },
      FORM_PRIVATE_PAY: 'Direct Signup v1 - Evaluation - Form - Private Pay',
      SUBMITTED: 'Direct Signup v1 - Evaluation - Submitted, redirecting to credentials creation',
      EXCLUSION: 'Direct Signup v1 - Evaluation Exclusion',
      DIVERTED: 'Direct Signup v1 - Diverted to Consult - Availability',
      IGNORED_DIVERT: 'Direct Signup v1 - Ignoring divert to consult due to being resumed LeadID',
    },
    CONSULT: {
      FORM: 'Direct Signup v1 - Consultation - Form',
      SUBMITTED: 'Direct Signup v1 - Consultation - Submitted, redirecting to thank you page',
    },
  },

  INSURANCE_CHECKS: {
    OK: 'Direct Signup v1 - Evaluation - Form - Insurance - Successful eligibility check',
    INACTIVE: 'Direct Signup v1 - Evaluation - Form - Insurance - Successful eligibility check',
    ERROR: 'Direct Signup v1 - Evaluation - Form - Insurance - FAILED eligibility check',
  },

  TIME_OPTIONS: {
    EARLY_MORNING: 'Direct Signup v1 - Time Options - Selected Early Morning',
    MORNING: 'Direct Signup v1 - Time Options - Selected Morning',
    AFTERNOON: 'Direct Signup v1 - Time Options - Selected Afternoon',
    EVENING: 'Direct Signup v1 - Time Options - Selected Evening',
    NO_SELECTION: 'Direct Signup v1 - Time Options - No Selection Made',
    FEATURE_DISABLED: 'Direct Signup v1 - Time Options - Feature Flag Disabled',
  },
};
